import { render, staticRenderFns } from "./Galerie.vue?vue&type=template&id=707ba027&scoped=true&"
import script from "./Galerie.vue?vue&type=script&lang=js&"
export * from "./Galerie.vue?vue&type=script&lang=js&"
import style0 from "./Galerie.vue?vue&type=style&index=0&id=707ba027&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ba027",
  null
  
)

export default component.exports